export default __webpack_public_path__ + "static/media/power_alerts_my_business.aa069792.png";